import {
    CurrentSelectedCompanyPermissions,
    CurrentUserPermissions,
    adminRoleType
} from "../AppState";
import {defaultCurrentUserPermissions} from "../reducers/Defaults/CurrentUserPermissions";

export interface WorkforceOneCompanyPermissionPayload{
    companyPermission: CurrentSelectedCompanyPermissions
    role: adminRoleType
    selectedCompany: string,
    requireCompleteSetup: boolean,
    link: string
}
export type COMPANY_PERMISSION_TYPE = 'WORKFORCE_ONE_COMPANY_PERMISSION_CHANGED';
export const COMPANY_PERMISSION = 'WORKFORCE_ONE_COMPANY_PERMISSION_CHANGED';
export interface WorkforceOneCompanyPermissionAction {
    type: COMPANY_PERMISSION_TYPE
    payload: WorkforceOneCompanyPermissionPayload
}
export function WorkforceOneUserCompanyPermissionChange(role: adminRoleType, companyPermission: CurrentSelectedCompanyPermissions, selectedCompany: string, requireCompleteSetup: boolean, link: string) : WorkforceOneCompanyPermissionAction {
    return {
        type: COMPANY_PERMISSION,
        payload: {
            companyPermission,
            role,
            selectedCompany,
            requireCompleteSetup,
            link
        }
    }
}

export interface WorkforceOneUserPermissionPayload{
    userPermission: CurrentUserPermissions
}
export type USER_PERMISSION_CHANGED_TYPE = 'WORKFORCE_ONE_PERMISSION_CHANGED';
export const USER_PERMISSION_CHANGED = 'WORKFORCE_ONE_PERMISSION_CHANGED';
export interface WorkforcePermissionChangedAction{
    type: USER_PERMISSION_CHANGED_TYPE,
    payload: WorkforceOneUserPermissionPayload
}
export function WorkforcePermissionChanged(userPermissionData: CurrentUserPermissions | null): WorkforcePermissionChangedAction {
    const userPermission = userPermissionData || defaultCurrentUserPermissions
    return {
        type: USER_PERMISSION_CHANGED,
        payload: {
            userPermission
        }
    }
}
export type WorkforceOnePermissionAction = |  WorkforceOneCompanyPermissionAction | WorkforcePermissionChangedAction
